/* eslint-disable no-unused-vars */
import { put, takeLeading, delay } from 'redux-saga/effects';
import { AUTHENTICATED, UNAUTHENTICATED, SIGN_OUT_REQUEST } from '../actions/authAction';
import { DESTROY_SESSION } from '../reducers/rootReducers';
import cookie from 'utils/cookie';

export function* appInitialize() {
	const access_token = cookie.get('access_token');
	const user_id = cookie.get('user_id');

	if (access_token && user_id) {
		yield put({ type: AUTHENTICATED });
	} else {
		yield put({ type: UNAUTHENTICATED });
	}
}

const clearCookie = () => {
	const allCookieName = Object.keys(cookie.getAll());
	allCookieName.map((name) => cookie.remove(name, { path: '/' }));
};

function* signOut() {
	yield clearCookie();
	yield delay(500);
	yield put({ type: DESTROY_SESSION });
	yield delay(8000);
	yield put({ type: UNAUTHENTICATED });
	yield delay(500);
	// yield (window.location = `${process.env.REACT_APP_AUTH_URL}/logout`);
}

export function* watchSignOut() {
	yield takeLeading(SIGN_OUT_REQUEST, signOut);
}
